import { Edit2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface PreviewStatusChipsProps {
  isEditable: boolean;
  hasUnsavedChanges: boolean;
  signatureFieldCount: number;
}

/**
 * Row of status chips above the double-buffered PDF viewer: the "hover to edit"
 * hint, an unsaved-changes flag, and the signer colour legend (primary /
 * counterparty) when signature fields are placed.
 */
export function PreviewStatusChips({
  isEditable,
  hasUnsavedChanges,
  signatureFieldCount,
}: PreviewStatusChipsProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center gap-2 text-sm text-globe-grey">
      {isEditable && (
        <span className="inline-flex items-center gap-1 rounded-full bg-[hsl(var(--bg))] border border-border px-3 py-1 font-semibold">
          <Edit2 className="w-3 h-3" />
          {t('GENERATEREVIEW_PREVIEW_HOVERTOEDIT')}
        </span>
      )}
      {hasUnsavedChanges && (
        <span className="inline-flex items-center gap-1 rounded-full bg-[hsl(var(--warning))/0.15] text-[hsl(var(--warning))] px-3 py-1 font-semibold">
          {t('GENERATEREVIEW_PREVIEW_UNSAVEDCHANGES')}
        </span>
      )}
      {signatureFieldCount > 0 && (
        <>
          <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-muted">
            <span className="h-2 w-2 rounded-full bg-selise-blue" />
            {t('GENERATEREVIEW_SIGNERS_PRIMARY')}
          </span>
          <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full bg-muted">
            <span className="h-2 w-2 rounded-full bg-poly-green" />
            {t('GENERATEREVIEW_SIGNERS_COUNTERPARTY')}
          </span>
        </>
      )}
    </div>
  );
}
